import React from 'react';
import DistributionBarCard from './DistributionBarCard';

const LikelihoodRecommendCard = ({ likelihood, totalResponses = 0 }) => {
  const promoters = Number(likelihood?.promoters ?? 0);
  const passives = Number(likelihood?.passives ?? 0);
  const detractors = Number(likelihood?.detractors ?? 0);
  const nps = Number(likelihood?.nps ?? 0);
  const total = totalResponses || promoters + passives + detractors || 1;

  const toPercent = (count) => Math.round((count / total) * 100);

  const items = [
    {
      label: 'Promoters (9-10)',
      count: promoters,
      percentage: toPercent(promoters),
      barClass: 'fi-bar-green',
    },
    {
      label: 'Passive (7-8)',
      count: passives,
      percentage: toPercent(passives),
      barClass: 'fi-bar-yellow',
    },
    {
      label: 'Detractors (1-6)',
      count: detractors,
      percentage: toPercent(detractors),
      barClass: 'fi-bar-red',
    },
  ];

  return (
    <DistributionBarCard
      title="Likelihood to Recommend"
      subtitle="(Q2)"
      icon="📊"
      items={items}
      getLabel={(item) => item.label}
      getCount={(item) => item.count}
      getPercentage={(item) => item.percentage}
      getBarClass={(item) => item.barClass}
      footer={
        <div className="fi-nps-footer">
          <span className="fi-nps-label">Net Promoter Score</span>
          <div className={`fi-nps-badge${nps >= 0 ? ' is-positive' : ' is-negative'}`}>
            {nps}
          </div>
        </div>
      }
    />
  );
};

export default LikelihoodRecommendCard;
